// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"b97ff74d","373":"aff0bbce","376":"2862c4b1","591":"976e329e","702":"476dd6bf","958":"4d9c50aa"}[chunkId] + ".chunk.css";
};